import { render, staticRenderFns } from "./subpage-header.vue?vue&type=template&id=65882bce"
import script from "./subpage-header.vue?vue&type=script&lang=js"
export * from "./subpage-header.vue?vue&type=script&lang=js"
import style0 from "./subpage-header.vue?vue&type=style&index=0&id=65882bce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports